import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
api.interceptors.response.use((r) => r, (e) => {
  if (e.response?.status === 401 && !/\/auth\/(login|totp)/.test(e.config?.url || "")) window.dispatchEvent(new Event("auth:logout"));
  return Promise.reject(e);
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || "field"}: ${String(x.msg).replace(/^Value error, /, "")}`).join(", ");
  return e?.message || "Request failed";
};

export const ipMatches = (ip) => !!ip?.ordersAllowed && /MATCH$/i.test(ip?.ipMatchStatus || "") && !/MISMATCH/i.test(ip?.ipMatchStatus || "");

export const dataReady = (s) => !!s && (s.data_source === "free" || (s.status === "connected" && s.data_access !== false));

const inr = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });
const inr2 = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const rupee = (v) => (v === null || v === undefined ? "—" : `${v < 0 ? "−" : ""}₹${inr.format(Math.abs(v))}`);
export const num = (v, d = 2) => (v === null || v === undefined ? "—" : d === 2 ? inr2.format(v) : inr.format(v));
export const pnlClass = (v) => (v > 0 ? "up" : v < 0 ? "down" : "text-slate-300");
export const istTime = (ts) =>
  new Date(ts * 1000).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hour12: false });
export const istDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false }) : "—";

export const STRATEGY_LABELS = {
  orb: "ORB breakout", bb_rsi_vwap: "Bollinger + RSI + VWAP", vwap_revert: "VWAP mean-reversion", fade: "First-hour fade",
  iron_condor: "Iron Condor", short_straddle: "Short Straddle", short_strangle: "Short Strangle",
  long_straddle: "Long Straddle", long_strangle: "Long Strangle", covered_call: "Covered Call",
};
export const STRUCTURES = ["iron_condor", "short_straddle", "short_strangle", "long_straddle", "long_strangle", "covered_call"];
export const isStructure = (k) => STRUCTURES.includes(k);
export const legText = (l) => `${l.side === "BUY" ? "+" : "−"}${l.strike == null ? "" : `${Math.round(l.strike)} `}${l.type}`;
export const spreadText = (t) => (t.legs ? t.legs.map(legText).join(" ") : `${t.buy_strike}/${t.sell_strike} ${t.opt_type}`);
export const dirClass = (d) => (d === "LONG" ? "up" : d === "SHORT" ? "down" : "text-indigo-300");
